module.exports = __webpack_public_path__ + "static/media/fundo_saopaulo_armadilhaOvos.61564e06.png";